module.exports = __webpack_public_path__ + "assets/images/img/onboarding_2.05f198c1acda33d149bc219e0bbc34ad.png";